import { action, makeObservable, observable } from "mobx";
import { PricingActualPlans, PricingActualTypePeriod } from "../../interfaces";

export class PricingActualStore {
	@observable typePeriod = PricingActualTypePeriod.MONTHLY;
	@observable plans = PricingActualPlans.SUBSCRIPTION_PLANS;

	@observable period_id = 1;
	@observable plan_id = 1;
	@observable instrument_id = 1;

	constructor() {
		makeObservable(this);
	}

	@action.bound
	changeTypePeriod(value: PricingActualTypePeriod) {
		this.typePeriod = value;
	}

	@action.bound
	setPlans(value: PricingActualPlans) {
		this.plans = value;
	}

	@action.bound
	setPeriodId(value: number) {
		this.period_id = value;
	}

	@action.bound
	setPlanId(value: number) {
		this.plan_id = value;
	}

	@action.bound
	setInstrumentId(value: number) {
		this.instrument_id = value;
	}
}
